import { type ReferralCard, type WebSection } from '@wbk/contentful/api';

import HeroSection from '../sections/sponsors/Hero';
import FormSection from '../sections/sponsors/Form';

const SponsorsSections = ({
  section,
  terms,
  benefits,
}: {
  section?: WebSection;
  terms?: WebSection | ({ __typename: 'AppReferralCard' } & ReferralCard) | null;
  benefits?: WebSection | ({ __typename: 'AppReferralCard' } & ReferralCard) | null;
}) => {
  switch (section?.renderType) {
    case 'hero-image':
    case 'hero':
      return <HeroSection section={section} />;
    case 'cards-grid':
      return <FormSection terms={terms} benefits={benefits} section={section} />;

    default:
      return <></>;
  }
};

export default SponsorsSections;
